import type { ComponentProps } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@jbnl/shared-ui";

/*
Two edits to shadcn's `badge`, per docs/adr/0025-jbnl-huisstijl-in-the-two-spas.md: the default
is Ocean Blue, since the red is reserved for actions and a badge labels a thing; and `muted` is
added for pills that state a fact without weighing it.
 */
const badgeVariants = cva(
  "inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-xs font-bold whitespace-nowrap [&>svg]:size-3",
  {
    variants: {
      variant: {
        default: "bg-secondary-surface text-secondary-active",
        destructive: "bg-destructive text-destructive-foreground",
        muted: "bg-muted text-muted-foreground",
        outline: "border text-foreground",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export type BadgeProps = ComponentProps<"span"> &
  VariantProps<typeof badgeVariants>;

export function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span
      data-slot="badge"
      className={cn(badgeVariants({ variant, className }))}
      {...props}
    />
  );
}

export { badgeVariants };
